//import bodyLocations from './bodyLocations';
import questionTypes from './questionTypes';

const questions = [{
  id: 'sex',
  type: questionTypes.sexSelector,
  name: 'Sex at birth',
  choices: [{
    id: 'male',
    label: 'Male'
  }, {
    id: 'female',
    label: 'Female'
  }]
}, {
  id: 'age',
  type: questionTypes.numberInput,
  name: 'Age',
  placeholder: 'Enter your age',
  min: 0,
  max: 100
}];

export default questions;
